/* §ctl — Complete the Look. 9 Sep 2026.

   Loaded ONLY by snippets/hov-ctl.liquid mode 'js', after hov.js, and that mode renders
   nothing while `ctl_live` is false — so while the feature is dark this file is not linked
   from any page. Kept out of hov.js on purpose: hov.js is fingerprinted into every page's
   <script src="…?v=…">, so editing it would change the HTML of every page on the site. This
   file can be pushed freely without moving a single existing byte.

   It OWNS no cart behaviour of its own. Every add goes through /cart/add.js and then hands
   over to window.hovBag (hov.js §bag) to refresh and open the drawer — the same path the two
   PDP forms and the sets page already use. If hov.js has not defined window.hovBag (an old
   cached copy, a script error above), every enhancement here degrades to a plain link or a
   native form post rather than to a dead button.

   It also does NO money maths and NO eligibility maths. Both figures and both sentence shapes
   are pre-built in Liquid, where the prices are, and travel on the markup. */
(function () {
  'use strict';

  /* ── §ctl-pdp — "Add both to bag" ───────────────────────────────────────────
     The anchor's variant is read off #pdp-form at CLICK time rather than baked into the
     button, so a sized anchor can only ever send the size the buyer actually picked, and the
     three controls on the page (buy button, sticky bar, this) cannot disagree. */
  var block = document.querySelector('[data-ctl]');
  var addBtn = block && block.querySelector('[data-ctl-add]');
  var pdpForm = document.getElementById('pdp-form');

  if (addBtn && pdpForm && window.fetch) {
    var label = addBtn.getAttribute('data-ctl-label') || 'Add both to bag';
    var adding = addBtn.getAttribute('data-ctl-adding') || 'Adding…';
    var nosize = addBtn.getAttribute('data-ctl-nosize') || 'Select a size';
    var compVid = parseInt(addBtn.getAttribute('data-ctl-add'), 10) || 0;

    /* Mirror the buy button's size gate. hov.js §size enables #pdp-form's button on a size
       pick; this listens to the same change event on the same fieldset so the two are never
       out of step, in either direction — including a buyer who somehow clears a selection. */
    var sizeBox = document.getElementById('pdp-sizes');
    if (sizeBox) {
      var syncSize = function () {
        var picked = sizeBox.querySelector('input[name="id"]:checked');
        var ready = !!(picked && !picked.disabled);
        addBtn.disabled = !ready;
        addBtn.textContent = ready ? label : nosize;
      };
      sizeBox.addEventListener('change', syncSize);
      syncSize();
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || !compVid) return;
      var anchorVid = 0;
      try {
        anchorVid = parseInt(new FormData(pdpForm).get('id'), 10) || 0;
      } catch (fdErr) {
        var f = pdpForm.querySelector('[name="id"]:checked') || pdpForm.querySelector('[name="id"]');
        anchorVid = f ? parseInt(f.value, 10) || 0 : 0;
      }
      /* No size chosen — refuse rather than send one nobody picked. Belt and braces: the
         button is already disabled in this state. */
      if (!anchorVid) {
        addBtn.disabled = true;
        addBtn.textContent = nosize;
        return;
      }
      addBtn.disabled = true;
      addBtn.classList.add('is-adding');
      addBtn.textContent = adding;
      /* One request, two lines. A multi-line /cart/add.js is atomic: if either piece cannot be
         added, neither is, and the buyer is never left holding half a pair. */
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: anchorVid, quantity: 1 },
            { id: compVid, quantity: 1 }
          ]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        if (window.hovBag && window.hovBag.added) window.hovBag.added(addBtn);
        else window.location.href = '/cart';
      }).catch(function () {
        /* Nothing was added (the add is atomic), so the honest recovery is to put the button
           back exactly as it was and let the buyer try again or use the buy button above. */
        addBtn.disabled = false;
        addBtn.classList.remove('is-adding');
        addBtn.textContent = label;
      }).then(function () {
        addBtn.classList.remove('is-adding');
        if (!addBtn.disabled) addBtn.textContent = label;
      });
    });
  }

  /* ── §ctl-bag — the one-line nudge in the bag drawer ─────────────────────────
     hov.js §bag rebuilds #bagd-body's innerHTML after every add, quantity change and remove,
     and exposes no hook — so this watches that element for the rebuild instead of patching
     hov.js. The bag's contents are read back out of the rendered lines (each line's name is
     an anchor to the piece's own page), which means no extra /cart.js request and no second
     copy of the cart's state to keep in step.

     The rule, from the brief: show the nudge only when EXACTLY ONE eligible piece with an
     approved companion is in the bag and that companion is not already there. Two eligible
     pieces already have their pair; none has nothing to complete. Nothing is ever pre-added.

     Writes only to #ctl-bag, never to #bagd-body, so the observer cannot retrigger itself. */
  var bagBox = document.getElementById('ctl-bag');
  var bagBody = document.getElementById('bagd-body');

  if (bagBox && bagBody && window.MutationObserver) {
    var pairs = {};
    try { pairs = JSON.parse(bagBox.getAttribute('data-ctl-pairs') || '{}') || {}; }
    catch (pErr) { pairs = {}; }
    var lead = bagBox.getAttribute('data-ctl-lead') || 'Complete the look';
    var addLab = bagBox.getAttribute('data-ctl-addlab') || 'Add';
    var addingLab = bagBox.getAttribute('data-ctl-adding') || 'Adding…';
    var csizeLab = bagBox.getAttribute('data-ctl-csize') || 'Choose a size';

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    var handleOf = function (href) {
      var m = /\/products\/([^/?#]+)/.exec(href || '');
      return m ? decodeURIComponent(m[1]) : '';
    };

    var hideNudge = function () {
      bagBox.hidden = true;
      bagBox.innerHTML = '';
    };

    var drawNudge = function () {
      var inBag = {}, anchors = [];
      Array.prototype.forEach.call(bagBody.querySelectorAll('.bagd-line .bagd-nm'), function (a) {
        var h = handleOf(a.getAttribute('href'));
        if (h) inBag[h] = true;
      });
      Object.keys(inBag).forEach(function (h) {
        if (Object.prototype.hasOwnProperty.call(pairs, h)) anchors.push(h);
      });
      if (anchors.length !== 1) return hideNudge();
      var c = pairs[anchors[0]];
      if (!c || !c.h || inBag[c.h]) return hideNudge();

      var action = c.s
        /* A sized companion is never added blind — the buyer goes and picks a size, the same
           rule the PDP block follows. */
        ? '<a class="ctl-nudge-btn" href="' + esc(c.u) + '">' + esc(csizeLab) + '</a>'
        : '<button type="button" class="ctl-nudge-btn" data-ctl-bagadd="' + (parseInt(c.v, 10) || 0) + '">' + esc(addLab) + '</button>';
      bagBox.innerHTML =
        '<div class="ctl-nudge">' +
          '<p class="ctl-nudge-txt"><b>' + esc(lead) + '</b> &mdash; ' + esc(c.l) + '</p>' +
          action +
        '</div>';
      bagBox.hidden = false;
    };

    bagBox.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ctl-bagadd]');
      if (!btn) return;
      var vid = parseInt(btn.getAttribute('data-ctl-bagadd'), 10) || 0;
      if (!vid || !window.fetch) return;
      btn.disabled = true;
      btn.textContent = addingLab;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        /* Hand back to hov.js §bag: it re-reads /cart.js and re-renders the lines, which
           fires the observer below, which hides this nudge because the pair is now complete. */
        if (window.hovBag && window.hovBag.open) window.hovBag.open(btn);
        else window.location.href = '/cart';
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = addLab;
      });
    });

    new MutationObserver(drawNudge).observe(bagBody, { childList: true, subtree: false });
    drawNudge();
  }

  /* ── §ctl-cart — the cart-page nudge ────────────────────────────────────────
     Server-rendered by snippets/hov-ctl.liquid mode 'cart' and it works with no script at
     all: the button is a real <form action="/cart/add">, which Shopify answers with a
     redirect back to /cart. The only thing added here is the label change, so a slow
     connection does not look like a dead button and cannot be double-submitted. */
  var cartForm = document.querySelector('.ctl-nudge-cart .ctl-nudge-form');
  if (cartForm) {
    cartForm.addEventListener('submit', function () {
      var b = cartForm.querySelector('button[type="submit"]');
      if (!b) return;
      var busy = b.getAttribute('data-ctl-adding') || 'Adding…';
      window.setTimeout(function () { b.disabled = true; b.textContent = busy; }, 0);
    });
  }
})();
